var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.validateData())?_c('b-button',{attrs:{"variant":"danger"},on:{"click":function($event){return _vm.exportTo()}}},[_vm._v(_vm._s(_vm.title ? _vm.title : 'Exportar'))]):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }